export enum AttachmentTypeEnum {
	BUTTON= 0,
	IMAGE= 1,
	URL= 2,
	IFRAME= 3,
	SATISFACTION_QUESTION= 14,
	EMOTION= 15,
	FEEDBACK_SCORE= 16,
}

export const AttachmentTypeFromIndex: {[id: number]: number} = {
	0: AttachmentTypeEnum.BUTTON,
	1: AttachmentTypeEnum.IMAGE,
    2: AttachmentTypeEnum.URL,
    3: AttachmentTypeEnum.IFRAME,
    14: AttachmentTypeEnum.SATISFACTION_QUESTION,
	15: AttachmentTypeEnum.EMOTION,
	16: AttachmentTypeEnum.FEEDBACK_SCORE,
};

export default AttachmentTypeEnum;
